module.exports = __webpack_public_path__ + "static/img/充值_2.04b70135.png";